export enum ChatChannels {
    WHATSAPP = "WHATSAPP",
    FACEBOOK_MESSENGER = 'FACEBOOK',
    OPTIWE_CHAT = 'OPTIWE_CHAT',
    INSTAGRAM = 'INSTAGRAM',
    SMS = 'SMS',
}